import type { AssignmentsHistoryType } from 'core/types';

export default ({ author, comment, due, responsible, status }: AssignmentsHistoryType) => {
  return {
    created: new Date().toISOString(),
    comment,
    status,
    due,
    responsible,
    author,
  };
};
